<template>
  <div id="app">
    <CreatePass />
  </div>
</template>

<script>
import CreatePass from './components/CreatePass.vue';



export default {
  name: 'App',
  components: {
    CreatePass
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
